import { useState } from "react";

/**
 * useColumnResize
 *
 * @param {number[]} defaultWidths  - Initial pixel widths, one per column
 * @returns {{ colWidths, setColWidths, buildGrid, getHandleProps }}
 *
 * buildGrid()  → CSS grid-template-columns string  e.g. "140px 80px 200px"
 * getHandleProps(colIndex) → mouse-down handler that starts a drag-resize
 */
const useColumnResize = (defaultWidths) => {
  const [colWidths, setColWidths] = useState([...defaultWidths]);

  const buildGrid = () => colWidths.map((w) => `${w}px`).join(" ");

  const getHandleProps = (index) => ({
    onMouseDown: (e) => {
      e.preventDefault();
      const startX = e.clientX;
      const startWidth = colWidths[index];

      const onMouseMove = (ev) => {
        const newWidth = Math.max(50, startWidth + (ev.clientX - startX));
        setColWidths((prev) => {
          const next = [...prev];
          next[index] = newWidth;
          return next;
        });
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
  });

  return { colWidths, setColWidths, buildGrid, getHandleProps };
};

export default useColumnResize;